import {Link} from 'react-router-dom';
import {NavbarProfileAvatarButton} from '@common/ui/navigation/navbar-new';

/** Figma `icon_mint 9` — 73.5×39, aspect-ratio 49/26 */
export const RECEIVE_HEADER_LOGO_SRC = '/images/drive-new/asset-4-2x-3.png';

/**
 * Receive / file-share screen header (Figma): mint logo left, profile right only.
 * Logo top 38px (pt 23 + mt 15); profile top 23px; horizontal inset 166px at lg.
 */
export function ReceivePageHeader() {
  return (
    <header className="relative z-30 mx-auto w-full max-w-[1895px] flex-shrink-0 px-[24px] pt-[23px] lg:px-[166px]">
      <div className="flex min-h-[60px] items-start justify-between">
        <Link
          to="/"
          className="mt-[15px] shrink-0"
          aria-label="CloudTransfer home"
        >
          <img
            src={RECEIVE_HEADER_LOGO_SRC}
            alt="CloudTransfer"
            width={74}
            height={39}
            className="h-[39px] w-[74px] shrink-0 object-cover"
          />
        </Link>
        <NavbarProfileAvatarButton />
      </div>
    </header>
  );
}
